import React, { useState, useEffect, useRef } from 'react';

import { useHistory } from 'react-router-dom';
import { logPageViews, VerifyTokenAcc, GetIpAddress, UserSession } from '../../Services/LoginService'
import { useParams } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import { TextField, Modal, Button, Typography, FormControl, InputAdornment, IconButton, Stepper, Step, StepLabel, Box } from '@mui/material';
import { IconUser, IconBuilding, IconBriefcase, IconMapPin, IconPhone, IconMail, IconLock, IconEye, IconEyeOff, IconLogin, IconCheck, IconArrowForward, IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { browserName, isMobile } from 'react-device-detect';
import * as Bowser from "bowser";
const VerifyTokenAccount = () => {
    const { id } = useParams();
    const [token, setToken] = useState('')
    const [isVerify, setisVerify] = useState(false)
    const [isVerify2, setisVerify2] = useState(false)
    //setToken(VerifyEmailAcc(id))
    useEffect(() => {
        logPage()
        async function logPage() {
            await logPageViews("Verify Token", id)
        }

        async function Vemail() {
            setToken(await VerifyTokenAcc(id))
        }
        if (isVerify) {
            setisVerify2(true)
        } else {
            Vemail()
        }


    }, [isVerify]);
    const [seconds, setSeconds] = useState(7);
    const history = useHistory();


    useEffect(() => {
       
    }, []);

    useEffect(() => {

        if (token !== '') {
            if (token.success = 'true') {

                //console.log(token.data.isSuccess)
                setisVerify(token.data.isSuccess)
                // Start the timer if verification is successful
                const interval = setInterval(() => {
                    setSeconds((prev) => prev - 1);
                }, 100);

                // Redirect after the timer reaches 0
                if (seconds === 0) {
                    clearInterval(interval);
                     console.log(token)
         CheckAthens()
        async function CheckAthens() {
            if (token.success && token.data.isSuccess) {
                localStorage.setItem("ip", await GetIpAddress())
                localStorage.setItem('token', token.data.token);
                localStorage.setItem('refreshToken', token.data.refreshToken);
                localStorage.setItem('sessionId', token.data.sessionId);
                localStorage.setItem('fullName', token.data.fullName);
                localStorage.setItem('email', token.data.fullName);
                localStorage.setItem('phoneNumber', token.data.phoneNumber);
                localStorage.setItem('address', token.data.address);
                localStorage.setItem('company', token.data.company);
                localStorage.setItem('occupation', token.data.occupation);
                localStorage.setItem('userId', token.data.userId);
                localStorage.setItem('groupId', token.data.groupId);
                localStorage.setItem('userType', token.data.userType);
                localStorage.setItem('gateway', token.data.eStoreWebModels[0].imGateWay.toLowerCase());
                localStorage.setItem('countryversionList', token.data.eStoreWebModelsCountryVersion);
                localStorage.setItem('Activecountryversion', token.data.eStoreWebModels[0].countryName);
                localStorage.setItem('subscriptionType', token.data.eStoreWebModels[0].subType);
                localStorage.setItem('subscriptionStart', token.data.eStoreWebModels[0].subcriptionStartDate);
                localStorage.setItem('subscriptionEnd', token.data.eStoreWebModels[0].subcriptionEndDate);
                localStorage.setItem('licenseCount', token.data.eStoreWebModels[0].licenseCount);
                var result = Bowser.getParser(window.navigator.userAgent);
                //result.parsedResult.browser.version
                // console.log(token.data.sessionId)
                // console.log(await GetIpAddress())
                // console.log(document.referrer)
                // console.log(browserName)
                // console.log(result.parsedResult.browser.version)
                console.log(await UserSession('Add', token.data.sessionId, '', token.data.userId, await GetIpAddress(), '', 'openathens', 'Web', browserName, result.parsedResult.browser.version, ''))

                //setError({ email: false, password: false });
                history.replace('/Home'); // Redirect to the home page
                //window.location.reload();
            }
        }

                    // history.push('/login'); // Use history.push for redirection
                }

                // Cleanup interval on component unmount
                return () => clearInterval(interval);
            }
        }
    }, [token, seconds, history]);



    // Function to immediately redirect to the login page
    const handleRedirect = () => {
        history.push('/Home'); // Redirect to the login page
    };
    return (<>

        {isVerify2 ?
            <div className="d-flex flex-column align-items-center justify-content-center vh-100 w-50 mx-auto text-center">
                <img src="/Verified.svg" alt="Illustration"
                    style={{ maxWidth: '240px', width: 'auto', height: 'auto', marginBottom: '20px' }}
                />
                <h2 style={{ fontWeight: 'bold', color: '#0262AB' }}>Verified!</h2>
                <h5 style={{ color: '#727272', marginBottom: '40px' }}>You can now access MIMS Drugs4dent®</h5>
                <span style={{ color: '#727272', marginBottom: '20px' }}>You will be redirected to the Home Page <strong>{seconds}</strong>, if you are not redirected automatically you can click the button below:</span>
                <Button
                    onClick={handleRedirect}
                    variant="contained"
                    color="primary"
                    sx={{
                        borderRadius: '32px',
                        padding: '16px 32px',
                        fontSize: '16px',
                        backgroundColor: '#0262AB',
                        '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                    }}
                >
                    Proceed to Home Page
                </Button>
            </div>
            :
            <div>Invalid Account</div>
        }

    </>);
}

export default VerifyTokenAccount;